import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { SidenavUtils } from '@/common/utils/SideNavUtils';

const hubSideNav = {
  id: 'hub',
  displayName: 'Hub',
  role: 'HUB_VIEW',
  icon: fas.faChartNetwork,
  precedence: 98,
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('hub'),

    // Common Menus (Includes pluginInfos, system, and subs)
    ...SidenavUtils.commonMenus('hub', ['pluginInfos', 'system', 'subs']),

    // Analytics Section
    {
      id: 'hubAnalytics',
      displayName: 'Analytics',
      role: 'HUB_VIEW',
      icon: fas.faBalanceScale,
      route: '/hub/analytics',
      precedence: 1
    }
  ]
};

export default hubSideNav;
